import { StoreError } from '@/types/storeError.interface';
import {
  createStoreSlice as createSlice,
  type PayloadAction,
} from '@/store/core';
import { RootState } from '../store';

interface MissingItemSignatureState {
  loading: boolean;
  error: StoreError | null;
  signature: string | null;
  signatureName: string | null;
}

const initialState: MissingItemSignatureState = {
  loading: false,
  error: null,
  signature: null,
  signatureName: null,
};

export const missingItemSignatureSlice = createSlice({
  name: 'missingItemSignature',
  initialState,
  reducers: {
    missingItemSignatureLoading: state => {
      state.loading = true;
    },
    setMissingItemSignature: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = null;
      state.signature = action.payload;
    },
    removeMissingItemSignature: state => {
      state.loading = false;
      state.error = null;
      state.signature = null;
    },
    setMissingItemSignatureName: (state, action: PayloadAction<string | null>) => {
      state.signatureName = action.payload;
    },
    fetchMissingItemSignatureFailure: (
      state,
      action: PayloadAction<StoreError>,
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  missingItemSignatureLoading,
  setMissingItemSignature,
  setMissingItemSignatureName,
  removeMissingItemSignature,
  fetchMissingItemSignatureFailure,
} = missingItemSignatureSlice.actions;

export const selectMissingItemSignature = (state: RootState) =>
  state[missingItemSignatureSlice.name] as typeof initialState;

